import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/page-header'
import { PostingPeriodsSection } from '@/features/ledger/posting-periods'

/**
 * Period control, as an addressable screen of its own.
 *
 * Closing a period is a month-end job with its own audience, separate from the branch manager
 * closing a day. Reopening a closed one is countersigned, and the screen reads the approval envelope
 * rather than the period's status — on a queued reopening the period comes back unchanged.
 */
export function LedgerPostingPeriodsPage() {
  return (
    <>
      <Link
        to="/ledger"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-text hover:text-brand-text-hover max-lg:min-h-11 max-lg:py-2"
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        All of the ledger
      </Link>

      <PageHeader
        title="Accounting periods"
        description="A calendar month of the ledger. Its state decides what may still post into it — and sealing one is the step taken after its numbers have been reported."
      />

      <PostingPeriodsSection />
    </>
  )
}
